import styled, { css } from 'styled-components';

export const DetailsWrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    padding: 0 16px;
  `};
`;

export const DetailsItem = styled.div`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};
    color: ${theme.v2.colors.neutral.lowPure};
    display: flex;
    font-size: ${theme.v2.font.sizes.xxs};
    justify-content: space-between;
    padding: 16px 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-wrap: wrap;
      gap: 8px;
    }
  `};
`;

export const DetailsTextContainer = styled.span`
  ${({ theme, truncableText }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    display: inline-block;
    font-size: ${theme.v2.font.sizes.xxs};

    ${truncableText && css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 85%;
    `}

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 100%;
      text-align: end;
    }
  `};
`;

export const FinancialTable = styled.table`
  ${({ theme }) => css`
    align-self: flex-end;
    border-spacing: 16px;
    border-collapse: collapse;
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 16px 0;
    width: 320px;

    tr:nth-last-child(2) {
      border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};

      td {
        padding-bottom: 16px;
      }
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 100%;
    }
  `};
`;

export const TableRow = styled.tr`
  ${({
    theme, noPaddingBottom, paddingTop, isVat,
  }) => css`
    td:first-child {
        text-align: left;
    }
    td:last-child {
        text-align: right;
    }

    td {
      color: ${isVat && theme.v2.colors.neutral.lowMedium};
      font-size: ${isVat && theme.v2.font.sizes.xxxs};
      padding-bottom: ${noPaddingBottom ? 0 : '16px'};
      padding-top: ${paddingTop && '8px'};
    }
  `};
`;

export const TableData = styled.td`
  ${({ isVat }) => css`
    display: ${isVat && 'flex'};
    gap: ${isVat && '4px'};
  `};
`;
